var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBedTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud_bed_table") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_bed_table",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-835",
    transform: "translate(19.000000, 48.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    strokeWidth: 0.2,
    points: "136.74 277.98 136.62 277.86 136.38 277.62 136.38 277.38 136.26 277.02"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.5,
    y1: 281.5,
    x2: 138.5,
    y2: 281.5,
    id: "Stroke-2",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    strokeWidth: 0.35,
    points: "56.0281046 91.9590476 56 92 56.0588235 91.9142857 56.1372549 91.8 56.2156863 91.6857143 56.372549 91.4571429 56.6078431 91.2285714 56.7647059 91.1142857 57 91"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    strokeWidth: 0.2,
    points: "77.26 361.02 77.5 361.14 77.62 361.38 77.74 361.62 77.74 361.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    strokeWidth: 0.2,
    points: "216.26 245.02 216.26 245.26 216.38 245.62 216.5 245.74 216.74 245.98"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239,
    y1: 394,
    x2: 240,
    y2: 388,
    id: "Stroke-6",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.44,
    y1: 221.5,
    x2: 200.56,
    y2: 221.5,
    id: "Stroke-7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5,
    y1: 72.5,
    x2: 29.5,
    y2: 72.5,
    id: "Stroke-8",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-9",
    strokeWidth: 0.2,
    points: "141.08 276 141.44 275.846154 141.68 275.538462 141.8 275.307692 141.92 275"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.4535,
    y1: 358.686,
    x2: 82.5465,
    y2: 358.314,
    id: "Stroke-10",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.44,
    y1: 360.5,
    x2: 90.56,
    y2: 360.5,
    id: "Stroke-11",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 132.5,
    x2: 5.5,
    y2: 132.5,
    id: "Stroke-12",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137,
    y1: 277.26,
    x2: 138,
    y2: 277.74,
    id: "Stroke-13",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-14",
    strokeWidth: 0.2,
    points: "137.74 277.44 137.5 277.44 137.26 277.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    strokeWidth: 0.2,
    points: "137.74 278.98 137.74 278.726 137.62 278.38 137.38 278.14 137.26 278.02"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-754"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.350399,271.480997 L136.4607,270.929468 L136.681302,270.488245 L137.012205,270.157327 L137.343108,269.936716 C137.343108,269.936716 137.85325,269.594768 138.004914,269.28683 C138.156577,268.978893 138.225515,268.392434 138.225515,268.392434 L138.225515,265.745095",
    id: "Stroke-16",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.343108,
    y1: 278.209652,
    x2: 136.791603,
    y2: 278.209652,
    id: "Stroke-18",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-20",
    strokeWidth: 0.2,
    points: "84.3644424 360.056567 84.4747433 359.615344 84.6953453 359.063815 84.9159473 358.732897 85.2468502 358.512286"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 409.235031,
    y1: 97.4184197,
    x2: 409.235031,
    y2: 98.0002828,
    id: "Stroke-22",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76.8286792,
    y1: 361.298059,
    x2: 77.6357147,
    y2: 361.600481,
    id: "Stroke-24",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-26",
    strokeWidth: 0.2,
    points: "78.5184902 363.255436 78.7390922 363.365742 78.9596942 363.255436"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-28",
    strokeWidth: 0.2,
    points: "81.7172188 360.939014 82.0481217 360.718402 82.3790247 360.277179 82.5996266 359.835955 82.5996266 359.394732"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-30",
    strokeWidth: 0.2,
    points: "83.4820345 361.600849 83.8129374 361.380237 84.1438404 360.939014 84.3644424 360.49779 84.3644424 360.056567"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.1948785,
    y1: 361.600849,
    x2: 77.6360824,
    y2: 361.600849,
    id: "Stroke-32",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-34",
    strokeWidth: 0.2,
    points: "78.0772863 362.483295 78.0772863 362.703907 78.1875873 363.034824 78.2978883 363.14513 78.5184902 363.255436"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.3657362,
    y1: 73.261446,
    x2: 28.3657362,
    y2: 73.261446,
    id: "Stroke-36",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5197841,
    y1: 77.0118437,
    x2: 22.5197841,
    y2: 77.0118437,
    id: "Stroke-38",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.649515,
    y1: 245.448824,
    x2: 217.973126,
    y2: 245.890048,
    id: "Stroke-40",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-42",
    strokeWidth: 0.2,
    points: "217.973126 245.890048 218.193728 246.000354 218.304029 246.220965 218.41433 246.441577 218.41433 246.772494"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-44",
    strokeWidth: 0.2,
    points: "217.090718 246.000354 217.31132 246.000354 217.531922 245.890048 217.973126 245.890048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.649515,239.161393 L216.649515,238.72017 L216.870117,238.278946 L217.201019,237.948029 L217.531922,237.727417 C217.531922,237.727417 218.040226,237.415803 218.193728,237.143716 C218.41433,236.753049 218.41433,236.183136 218.41433,236.183136 L218.41433,235.080078",
    id: "Stroke-46",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.59941,
    y1: 393.920453,
    x2: 238.709711,
    y2: 393.920453,
    id: "Stroke-48",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.1961723,
    y1: 79.21796,
    x2: 21.1961723,
    y2: 79.21796,
    id: "Stroke-50",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.424244,
    y1: 268.50274,
    x2: 141.093341,
    y2: 268.50274,
    id: "Stroke-52",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-54",
    strokeWidth: 0.2,
    points: "141.865448 269.385186 141.865448 269.054269 141.755147 268.833657 141.534545 268.613046 141.424244 268.50274"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.9336908,
    y1: 403.627364,
    x2: 56.9336908,
    y2: 296.741029,
    id: "Stroke-56",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 386.08874,
    x2: 58.6985066,
    y2: 402.855224,
    id: "Stroke-58",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 296.079194,
    x2: 58.6985066,
    y2: 386.08874,
    id: "Stroke-60",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 296.1895,
    x2: 138.556418,
    y2: 265.524483,
    id: "Stroke-62",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.989397,
    y1: 360.056567,
    x2: 137.56371,
    y2: 355.313417,
    id: "Stroke-64",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.364226,
    y1: 162.719463,
    x2: 430.523121,
    y2: 89.9176242,
    id: "Stroke-66",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.751014,
    y1: 91.5722114,
    x2: 244.665964,
    y2: 162.388545,
    id: "Stroke-68",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.9343587,
    y1: 78.3494856,
    x2: 44.5802565,
    y2: 88.152915,
    id: "Stroke-70",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.5799807,
    y1: 88.1527311,
    x2: 44.5799807,
    y2: 125.673254,
    id: "Stroke-72",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75403462,
    y1: 123.671204,
    x2: 5.75403462,
    y2: 74.6954216,
    id: "Stroke-74",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75403462,
    y1: 74.6954216,
    x2: 42.704864,
    y2: 88.9248718,
    id: "Stroke-76",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.704864,
    y1: 88.9248718,
    x2: 42.704864,
    y2: 121.906311,
    id: "Stroke-78",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.5371675,
    y1: 154.998056,
    x2: 65.5371675,
    y2: 275.341701,
    id: "Stroke-80",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.338439,
    y1: 153.784692,
    x2: 62.338439,
    y2: 276.555065,
    id: "Stroke-82",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.1324194,
    y1: 153.012551,
    x2: 60.1324194,
    y2: 275.672618,
    id: "Stroke-84",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.6912154,
    y1: 152.791939,
    x2: 59.6912154,
    y2: 277.547817,
    id: "Stroke-86",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.4924869,
    y1: 151.578575,
    x2: 56.4924869,
    y2: 278.761181,
    id: "Stroke-88",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.2864672,
    y1: 150.806435,
    x2: 54.2864672,
    y2: 277.878734,
    id: "Stroke-90",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.7349623,
    y1: 150.585823,
    x2: 53.7349623,
    y2: 279.753933,
    id: "Stroke-92",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.888255,
    y1: 239.823228,
    x2: 153.888255,
    y2: 188.861941,
    id: "Stroke-94",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.094275,
    y1: 240.595369,
    x2: 156.094275,
    y2: 189.744387,
    id: "Stroke-96",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.293003,
    y1: 239.382005,
    x2: 159.293003,
    y2: 190.957751,
    id: "Stroke-98",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.734207,
    y1: 237.617112,
    x2: 159.734207,
    y2: 191.068057,
    id: "Stroke-100",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.940227,
    y1: 238.389252,
    x2: 161.940227,
    y2: 191.950504,
    id: "Stroke-102",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.138955,
    y1: 237.175888,
    x2: 165.138955,
    y2: 193.163868,
    id: "Stroke-104",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.69046,
    y1: 235.300689,
    x2: 165.69046,
    y2: 193.384479,
    id: "Stroke-106",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.786179,
    y1: 236.183136,
    x2: 167.786179,
    y2: 194.15662,
    id: "Stroke-108",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170.984907,
    y1: 234.969772,
    x2: 170.984907,
    y2: 195.369984,
    id: "Stroke-110",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.556418,
    y1: 281.960049,
    x2: 139.438826,
    y2: 282.290967,
    id: "Stroke-112",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.093341,
    y1: 264.531731,
    x2: 141.093341,
    y2: 281.629132,
    id: "Stroke-114",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.093341,
    y1: 281.629132,
    x2: 139.438826,
    y2: 282.290967,
    id: "Stroke-116",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.438826,
    y1: 282.290967,
    x2: 139.438826,
    y2: 265.193565,
    id: "Stroke-118",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.883765,
    y1: 261.774085,
    x2: 180.139889,
    y2: 269.274881,
    id: "Stroke-120",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.943962,
    y1: 270.157327,
    x2: 199.883765,
    y2: 261.774085,
    id: "Stroke-122",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.089785,
    y1: 277.768428,
    x2: 221.943962,
    y2: 270.157327,
    id: "Stroke-124",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.943962,
    y1: 272.473749,
    x2: 205.067911,
    y2: 278.871487,
    id: "Stroke-126",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.61288,
    y1: 168.455365,
    x2: 100.61288,
    y2: 261.884391,
    id: "Stroke-128",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.5244527,
    y1: 167.242001,
    x2: 97.5244527,
    y2: 263.097755,
    id: "Stroke-130",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.318433,
    y1: 166.46986,
    x2: 95.318433,
    y2: 262.215308,
    id: "Stroke-132",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7669281,
    y1: 166.249249,
    x2: 94.7669281,
    y2: 264.090507,
    id: "Stroke-134",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.6785006,
    y1: 165.035885,
    x2: 91.6785006,
    y2: 265.303871,
    id: "Stroke-136",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.4724809,
    y1: 164.263744,
    x2: 89.4724809,
    y2: 264.531731,
    id: "Stroke-138",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.920976,
    y1: 164.043132,
    x2: 88.920976,
    y2: 266.296624,
    id: "Stroke-140",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.8325484,
    y1: 162.829768,
    x2: 85.8325484,
    y2: 267.509988,
    id: "Stroke-142",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.6265288,
    y1: 161.947322,
    x2: 83.6265288,
    y2: 266.737847,
    id: "Stroke-144",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.327592,
    y1: 360.387485,
    x2: 124.327592,
    y2: 308.543751,
    id: "Stroke-146",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.812542,
    y1: 253.280537,
    x2: 118.812542,
    y2: 175.404631,
    id: "Stroke-148",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.908261,
    y1: 254.052678,
    x2: 120.908261,
    y2: 176.287078,
    id: "Stroke-150",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.10699,
    y1: 252.839314,
    x2: 124.10699,
    y2: 177.500442,
    id: "Stroke-152",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.658495,
    y1: 251.074421,
    x2: 124.658495,
    y2: 177.610748,
    id: "Stroke-154",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.754213,
    y1: 251.846562,
    x2: 126.754213,
    y2: 178.493194,
    id: "Stroke-156",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.504447,
    y1: 248.757999,
    x2: 130.504447,
    y2: 179.92717,
    id: "Stroke-158",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.600165,
    y1: 249.640445,
    x2: 132.600165,
    y2: 180.699311,
    id: "Stroke-160",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.798894,
    y1: 248.427081,
    x2: 135.798894,
    y2: 181.912675,
    id: "Stroke-162",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.952942,
    y1: 250.633198,
    x2: 129.952942,
    y2: 179.706558,
    id: "Stroke-164",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.536412,
    y1: 233.094573,
    x2: 171.536412,
    y2: 195.590596,
    id: "Stroke-166",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.632131,
    y1: 233.866714,
    x2: 173.632131,
    y2: 196.473042,
    id: "Stroke-168",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.83086,
    y1: 232.65335,
    x2: 176.83086,
    y2: 197.686406,
    id: "Stroke-170",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.382365,
    y1: 230.888457,
    x2: 177.382365,
    y2: 197.796712,
    id: "Stroke-172",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.478083,
    y1: 231.660597,
    x2: 179.478083,
    y2: 198.679159,
    id: "Stroke-174",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 182.676812,
    y1: 230.447234,
    x2: 182.676812,
    y2: 199.892523,
    id: "Stroke-176",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.228317,
    y1: 228.572035,
    x2: 183.228317,
    y2: 200.113134,
    id: "Stroke-178",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.434336,
    y1: 229.454481,
    x2: 185.434336,
    y2: 200.885275,
    id: "Stroke-180",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.522764,
    y1: 228.241117,
    x2: 188.522764,
    y2: 202.098639,
    id: "Stroke-182",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.350399,
    y1: 246.551883,
    x2: 136.350399,
    y2: 182.133286,
    id: "Stroke-184",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.556418,
    y1: 247.324023,
    x2: 138.556418,
    y2: 183.015733,
    id: "Stroke-186",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.644846,
    y1: 246.110659,
    x2: 141.644846,
    y2: 184.229097,
    id: "Stroke-188",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.196351,
    y1: 244.345766,
    x2: 142.196351,
    y2: 184.339403,
    id: "Stroke-190",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.402371,
    y1: 245.117907,
    x2: 144.402371,
    y2: 185.221849,
    id: "Stroke-192",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147.490798,
    y1: 243.904543,
    x2: 147.490798,
    y2: 186.435213,
    id: "Stroke-194",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148.042303,
    y1: 242.029344,
    x2: 148.042303,
    y2: 186.655825,
    id: "Stroke-196",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.248323,
    y1: 242.911791,
    x2: 150.248323,
    y2: 187.427965,
    id: "Stroke-198",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.33675,
    y1: 241.698427,
    x2: 153.33675,
    y2: 188.641329,
    id: "Stroke-200",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.819078,
    y1: 230.667845,
    x2: 206.170921,
    y2: 223.828885,
    id: "Stroke-202",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.9336908,
    y1: 294.534912,
    x2: 223.819078,
    y2: 230.667845,
    id: "Stroke-204",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 233.646102,
    x2: 56.9336908,
    y2: 296.741029,
    id: "Stroke-206",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.41433,
    y1: 249.523797,
    x2: 221.061554,
    y2: 250.412678,
    id: "Stroke-208",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 351.121796,
    x2: 58.6985066,
    y2: 368.219197,
    id: "Stroke-210",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.20982086,
    y1: 127.090684,
    x2: 239.923022,
    y2: 217.320841,
    id: "Stroke-212",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.069203,
    y1: 217.320841,
    x2: 1.45404271,
    y2: 125.283507,
    id: "Stroke-214",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.1948785,
    y1: 361.600849,
    x2: 58.9952162,
    y2: 368.550115,
    id: "Stroke-216",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.446421,
    y1: 368.108892,
    x2: 103.446421,
    y2: 351.563019,
    id: "Stroke-218",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.9952162,
    y1: 385.095987,
    x2: 103.446512,
    y2: 368.108892,
    id: "Stroke-220",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.9952162,
    y1: 368.550115,
    x2: 58.9952162,
    y2: 385.095987,
    id: "Stroke-222",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 385.537211,
    x2: 134.806185,
    y2: 356.416475,
    id: "Stroke-224",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.806185,
    y1: 358.732897,
    x2: 110.319367,
    y2: 368.108892,
    id: "Stroke-226",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.806185,
    y1: 358.732897,
    x2: 134.806185,
    y2: 356.416475,
    id: "Stroke-228",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.812542,
    y1: 175.404631,
    x2: 3.76861693,
    y2: 131.445006,
    id: "Stroke-230",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.400682,
    y1: 220.078487,
    x2: 118.812542,
    y2: 175.404631,
    id: "Stroke-232",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.458077,
    y1: 5.97489836,
    x2: 237.717002,
    y2: 15.6818101,
    id: "Stroke-234",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.523029,
    y1: 89.9176242,
    x2: 211.354975,
    y2: 6.06222379,
    id: "Stroke-236",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.523029,
    y1: 89.9176242,
    x2: 431.074534,
    y2: 89.6970126,
    id: "Stroke-238",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.074534,
    y1: 89.6970126,
    x2: 431.074534,
    y2: 89.6970126,
    id: "Stroke-240",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6592497,
    y1: 137.128513,
    x2: 18.6592497,
    y2: 399.987272,
    id: "Stroke-242",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4605211,
    y1: 267.840905,
    x2: 15.4605211,
    y2: 402.193389,
    id: "Stroke-244",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2545015,
    y1: 268.613046,
    x2: 13.2545015,
    y2: 401.310942,
    id: "Stroke-246",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8132976,
    y1: 268.833657,
    x2: 12.8132976,
    y2: 402.193389,
    id: "Stroke-248",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61456904,
    y1: 133.598727,
    x2: 9.61456904,
    y2: 404.399505,
    id: "Stroke-250",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.40854937,
    y1: 132.826587,
    x2: 7.40854937,
    y2: 403.517059,
    id: "Stroke-252",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.85704446,
    y1: 132.605975,
    x2: 6.85704446,
    y2: 404.399505,
    id: "Stroke-254",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.76861693,
    y1: 126.925225,
    x2: 3.76861693,
    y2: 406.605621,
    id: "Stroke-256",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.01109235,
    y1: 125.87732,
    x2: 1.01109235,
    y2: 405.612869,
    id: "Stroke-258",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.01109235,
    y1: 125.87732,
    x2: 4.20982086,
    y2: 127.090684,
    id: "Stroke-260",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4605211,
    y1: 135.915149,
    x2: 15.4605211,
    y2: 257.141241,
    id: "Stroke-262",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2545015,
    y1: 135.032703,
    x2: 13.2545015,
    y2: 258.03288,
    id: "Stroke-264",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8132976,
    y1: 258.244299,
    x2: 12.8132976,
    y2: 134.812091,
    id: "Stroke-266",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.61288,
    y1: 296.124052,
    x2: 100.61288,
    y2: 280.084667,
    id: "Stroke-268",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 348.805374,
    x2: 81.6411111,
    y2: 340.422132,
    id: "Stroke-270",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 332.590419,
    x2: 103.591007,
    y2: 315.493018,
    id: "Stroke-272",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 317.699134,
    x2: 58.6985066,
    y2: 334.906841,
    id: "Stroke-274",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 313.286901,
    x2: 222.054263,
    y2: 250.743504,
    id: "Stroke-276",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.711727,
    y1: 297.518593,
    x2: 58.6986904,
    y2: 315.492926,
    id: "Stroke-278",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 253.059926,
    x2: 179.808986,
    y2: 269.164575,
    id: "Stroke-280",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.687838,
    y1: 222.615521,
    x2: 473.540504,
    y2: 133.929645,
    id: "Stroke-282",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.775597,
    y1: 128.634966,
    x2: 473.540413,
    y2: 129.2968,
    id: "Stroke-284",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.540413,
    y1: 129.2968,
    x2: 241.687746,
    y2: 217.982676,
    id: "Stroke-286",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.687838,
    y1: 217.982676,
    x2: 239.923022,
    y2: 217.320841,
    id: "Stroke-288",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.069203,
    y1: 217.320841,
    x2: 471.700224,
    y2: 129.469613,
    id: "Stroke-290",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 311.74262,
    x2: 100.61288,
    y2: 295.748276,
    id: "Stroke-292",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.335816,
    y1: 281.849744,
    x2: 138.556418,
    y2: 281.960049,
    id: "Stroke-294",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.663163,
    y1: 9.17376701,
    x2: 209.479951,
    y2: 5.42336928,
    id: "Stroke-296",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.704864,
    y1: 126.428298,
    x2: 42.704864,
    y2: 121.906678,
    id: "Stroke-298",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.839442,
    y1: 90.3588474,
    x2: 429.751014,
    y2: 91.5722114,
    id: "Stroke-300",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.962427,
    y1: 114.015952,
    x2: 432.962427,
    y2: 129.170133,
    id: "Stroke-302",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.962427,
    y1: 90.314817,
    x2: 432.962427,
    y2: 113.868786,
    id: "Stroke-304",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1834574,
    y1: 83.5198869,
    x2: 53.1834574,
    y2: 91.0206823,
    id: "Stroke-306",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9265573,
    y1: 75.0779989,
    x2: 30.9265573,
    y2: 82.5787944,
    id: "Stroke-308",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.3730273,
    y1: 73.7026693,
    x2: 29.1378431,
    y2: 72.9305285,
    id: "Stroke-310",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.1378431,
    y1: 72.9305285,
    x2: 54.9482731,
    y2: 82.858052,
    id: "Stroke-312",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1834574,
    y1: 83.5198869,
    x2: 27.3730273,
    y2: 73.7026693,
    id: "Stroke-314",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.45958743,
    y1: 405.392257,
    x2: 0.45958743,
    y2: 125.656709,
    id: "Stroke-316",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 141.540746,
    x2: 30.3511539,
    y2: 395.464734,
    id: "Stroke-318",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.1524254,
    y1: 140.327382,
    x2: 27.1524254,
    y2: 397.67085,
    id: "Stroke-320",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0567067,
    y1: 139.555241,
    x2: 25.0567067,
    y2: 396.788404,
    id: "Stroke-322",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5052018,
    y1: 139.33463,
    x2: 24.5052018,
    y2: 397.67085,
    id: "Stroke-324",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3064733,
    y1: 138.121266,
    x2: 21.3064733,
    y2: 399.876967,
    id: "Stroke-326",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.2107546,
    y1: 137.349125,
    x2: 19.2107546,
    y2: 399.104826,
    id: "Stroke-328",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 394.802899,
    x2: 30.9026588,
    y2: 394.582287,
    id: "Stroke-330",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9026588,
    y1: 394.582287,
    x2: 30.9026588,
    y2: 347.812622,
    id: "Stroke-332",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.467236,
    y1: 163.601909,
    x2: 238.378808,
    y2: 162.388545,
    id: "Stroke-334",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.467236,
    y1: 202.524235,
    x2: 241.467236,
    y2: 163.601909,
    id: "Stroke-336",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.91293,
    y1: 9.17376701,
    x2: 195.91293,
    y2: 28.8082022,
    id: "Stroke-338",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.72336,
    y1: 18.9909846,
    x2: 195.91293,
    y2: 9.17376701,
    id: "Stroke-340",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.91293,
    y1: 9.17376701,
    x2: 197.677745,
    y2: 8.51193212,
    id: "Stroke-342",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.962568,
    y1: 9.00058688,
    x2: 223.487992,
    y2: 18.328782,
    id: "Stroke-344",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.677745,
    y1: 8.51193212,
    x2: 198.962752,
    y2: 9.00095457,
    id: "Stroke-346",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.6465348,
    y1: 149.372459,
    x2: 50.6465348,
    y2: 280.967297,
    id: "Stroke-348",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.377696,
    y1: 279.423016,
    x2: 102.377696,
    y2: 296.56362,
    id: "Stroke-350",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.467236,
    y1: 202.524235,
    x2: 20.7568067,
    y2: 118.027223,
    id: "Stroke-352",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.1961723,
    y1: 78.8284886,
    x2: 240.364226,
    y2: 162.719738,
    id: "Stroke-354",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.5799807,
    y1: 88.1527311,
    x2: 240.364226,
    y2: 163.159767,
    id: "Stroke-356",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.783556,
    y1: 415.430087,
    x2: 243.783556,
    y2: 398.001768,
    id: "Stroke-358",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.061554,
    y1: 233.97702,
    x2: 141.093341,
    y2: 264.642036,
    id: "Stroke-360",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.41433,
    y1: 249.523797,
    x2: 175.838151,
    y2: 265.849977,
    id: "Stroke-362",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.0750239,
    y1: 161.72671,
    x2: 83.0750239,
    y2: 268.613046,
    id: "Stroke-364",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.8762954,
    y1: 160.513346,
    x2: 79.8762954,
    y2: 269.82641,
    id: "Stroke-366",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.7805767,
    y1: 159.741206,
    x2: 77.7805767,
    y2: 268.943963,
    id: "Stroke-368",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.2290718,
    y1: 159.520594,
    x2: 77.2290718,
    y2: 270.819162,
    id: "Stroke-370",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.0303432,
    y1: 158.30723,
    x2: 74.0303432,
    y2: 272.032526,
    id: "Stroke-372",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.9346246,
    y1: 157.535089,
    x2: 71.9346246,
    y2: 271.15008,
    id: "Stroke-374",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.3831196,
    y1: 157.314478,
    x2: 71.3831196,
    y2: 273.025278,
    id: "Stroke-376",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.1843911,
    y1: 156.101114,
    x2: 68.1843911,
    y2: 274.238642,
    id: "Stroke-378",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.0886724,
    y1: 155.218667,
    x2: 66.0886724,
    y2: 273.466502,
    id: "Stroke-380",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.261038,
    y1: 175.18402,
    x2: 118.261038,
    y2: 255.155736,
    id: "Stroke-382",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.062309,
    y1: 173.970656,
    x2: 115.062309,
    y2: 256.3691,
    id: "Stroke-384",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.856289,
    y1: 173.198515,
    x2: 112.856289,
    y2: 255.486654,
    id: "Stroke-386",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.415085,
    y1: 172.977903,
    x2: 112.415085,
    y2: 257.361853,
    id: "Stroke-388",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.458832,
    y1: 170.771787,
    x2: 106.458832,
    y2: 259.567969,
    id: "Stroke-390",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.370405,
    y1: 169.558423,
    x2: 103.370405,
    y2: 260.781333,
    id: "Stroke-392",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.164385,
    y1: 168.675977,
    x2: 101.164385,
    y2: 260.009192,
    id: "Stroke-394",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.216357,
    y1: 171.76454,
    x2: 109.216357,
    y2: 258.575217,
    id: "Stroke-396",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.010337,
    y1: 257.803076,
    x2: 107.010337,
    y2: 170.992399,
    id: "Stroke-398",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9265573,
    y1: 75.0779989,
    x2: 20.7356657,
    y2: 78.9975323,
    id: "Stroke-400",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.4353474,
    y1: 75.0649461,
    x2: 29.1808605,
    y2: 74.3902422,
    id: "Stroke-402",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.8269991,
    y1: 78.3910341,
    x2: 27.4350716,
    y2: 75.0653138,
    id: "Stroke-404",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.074269,
    y1: 226.365918,
    x2: 189.074269,
    y2: 202.31925,
    id: "Stroke-406",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.280288,
    y1: 227.138059,
    x2: 191.280288,
    y2: 203.201697,
    id: "Stroke-408",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.368716,
    y1: 225.924695,
    x2: 194.368716,
    y2: 204.415061,
    id: "Stroke-410",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.920221,
    y1: 224.159802,
    x2: 194.920221,
    y2: 204.525367,
    id: "Stroke-412",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.126241,
    y1: 224.931943,
    x2: 197.126241,
    y2: 205.407813,
    id: "Stroke-414",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.214668,
    y1: 223.718579,
    x2: 200.214668,
    y2: 206.621177,
    id: "Stroke-416",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.8890102,
    y1: 148.269401,
    x2: 47.8890102,
    y2: 282.070355,
    id: "Stroke-418",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8005827,
    y1: 147.056037,
    x2: 44.8005827,
    y2: 283.283719,
    id: "Stroke-420",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.594563,
    y1: 146.283896,
    x2: 42.594563,
    y2: 282.401273,
    id: "Stroke-422",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.0430581,
    y1: 146.063284,
    x2: 42.0430581,
    y2: 284.276472,
    id: "Stroke-424",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.9546306,
    y1: 144.84992,
    x2: 38.9546306,
    y2: 285.489836,
    id: "Stroke-426",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.7486109,
    y1: 144.07778,
    x2: 36.7486109,
    y2: 284.607389,
    id: "Stroke-428",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.197106,
    y1: 286.592894,
    x2: 36.197106,
    y2: 394.25137,
    id: "Stroke-430",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.197106,
    y1: 143.857168,
    x2: 36.197106,
    y2: 286.592894,
    id: "Stroke-432",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.9983775,
    y1: 142.643804,
    x2: 32.9983775,
    y2: 395.464734,
    id: "Stroke-434",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.220361,
    y1: 19.1229839,
    x2: 54.9478136,
    y2: 84.1813541,
    id: "Stroke-436",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.98821,
    y1: 28.8580237,
    x2: 223.488084,
    y2: 18.3293336,
    id: "Stroke-438",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.9482731,
    y1: 82.858052,
    x2: 195.988302,
    y2: 28.8578398,
    id: "Stroke-440",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.1834574,
    y1: 83.5198869,
    x2: 54.9482731,
    y2: 84.1817218,
    id: "Stroke-442",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.838151,
    y1: 268.438027,
    x2: 175.838151,
    y2: 251.294665,
    id: "Stroke-444",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.355822,
    y1: 297.623475,
    x2: 105.355822,
    y2: 367.417642,
    id: "Stroke-446",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.356001,
    y1: 287.034117,
    x2: 226.356001,
    y2: 216.659007,
    id: "Stroke-448",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.170921,
    y1: 223.828885,
    x2: 202.972193,
    y2: 222.615521,
    id: "Stroke-450",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 402.855224,
    x2: 58.6985066,
    y2: 402.965529,
    id: "Stroke-452",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 285.37953,
    x2: 222.054263,
    y2: 253.059926,
    id: "Stroke-454",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 250.743504,
    x2: 222.054263,
    y2: 233.646102,
    id: "Stroke-456",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.260282,
    y1: 286.261976,
    x2: 224.260282,
    y2: 215.77656,
    id: "Stroke-458",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.55473,
    y1: 288.247481,
    x2: 229.55473,
    y2: 251.846562,
    id: "Stroke-460",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.106235,
    y1: 288.468093,
    x2: 230.106235,
    y2: 252.067173,
    id: "Stroke-462",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 232.312254,
    y1: 289.240233,
    x2: 232.312254,
    y2: 218.865123,
    id: "Stroke-464",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.6411111,
    y1: 306.99947,
    x2: 81.6411111,
    y2: 306.778858,
    id: "Stroke-466",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.2116883,
    y1: 394.913205,
    x2: 56.9336908,
    y2: 403.627364,
    id: "Stroke-468",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.225515,
    y1: 282.838635,
    x2: 138.225515,
    y2: 278.981609,
    id: "Stroke-470",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.400682,
    y1: 290.453597,
    x2: 235.400682,
    y2: 220.078487,
    id: "Stroke-472",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.839442,
    y1: 90.3588474,
    x2: 431.074626,
    y2: 89.6970126,
    id: "Stroke-474",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.319367,
    y1: 368.108892,
    x2: 58.6985066,
    y2: 387.853633,
    id: "Stroke-476",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.197106,
    y1: 286.592894,
    x2: 56.9336908,
    y2: 294.534912,
    id: "Stroke-478",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.355067,
    y1: 13.6730493,
    x2: 211.355067,
    y2: 6.06194803,
    id: "Stroke-480",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.923022,
    y1: 221.733074,
    x2: 235.400682,
    y2: 220.078487,
    id: "Stroke-482",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.766173,
    y1: 221.84338,
    x2: 200.766173,
    y2: 206.841789,
    id: "Stroke-484",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.972193,
    y1: 222.615521,
    x2: 202.972193,
    y2: 207.61393,
    id: "Stroke-486",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.170921,
    y1: 223.828885,
    x2: 206.170921,
    y2: 208.827294,
    id: "Stroke-488",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 402.855224,
    x2: 134.916486,
    y2: 373.734488,
    id: "Stroke-490",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.41433,
    y1: 249.523797,
    x2: 218.41433,
    y2: 246.772586,
    id: "Stroke-492",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.10681103,
    y1: 124.663956,
    x2: 3.65831594,
    y2: 124.443345,
    id: "Stroke-494",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.220361,
    y1: 26.4031678,
    x2: 225.220361,
    y2: 19.1229839,
    id: "Stroke-496",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.061554,
    y1: 233.97702,
    x2: 221.061554,
    y2: 233.97702,
    id: "Stroke-498",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.2116883,
    y1: 394.913205,
    x2: 32.9983775,
    y2: 395.464734,
    id: "Stroke-500",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 366.013081,
    x2: 103.591007,
    y2: 348.805374,
    id: "Stroke-502",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.989397,
    y1: 308.874669,
    x2: 124.989397,
    y2: 360.056567,
    id: "Stroke-504",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.467236,
    y1: 202.524235,
    x2: 432.962611,
    y2: 129.169949,
    id: "Stroke-506",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.170921,
    y1: 223.828885,
    x2: 206.170921,
    y2: 223.828885,
    id: "Stroke-508",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.9336908,
    y1: 294.534912,
    x2: 56.9336908,
    y2: 296.741029,
    id: "Stroke-510",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.9336908,
    y1: 296.741029,
    x2: 36.197106,
    y2: 288.909316,
    id: "Stroke-512",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.446421,
    y1: 351.563019,
    x2: 85.2467583,
    y2: 358.512286,
    id: "Stroke-514",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.891056,
    y1: 0.790525013,
    x2: 198.891056,
    y2: 8.92925579,
    id: "Stroke-516",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118.812542,
    y1: 175.404631,
    x2: 118.812542,
    y2: 175.404631,
    id: "Stroke-518",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.41433,
    y1: 228.572035,
    x2: 218.41433,
    y2: 213.570444,
    id: "Stroke-520",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.510049,
    y1: 229.344175,
    x2: 220.510049,
    y2: 214.342584,
    id: "Stroke-522",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.708777,
    y1: 230.557539,
    x2: 223.708777,
    y2: 215.555948,
    id: "Stroke-524",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.55473,
    y1: 251.846562,
    x2: 229.55473,
    y2: 217.872371,
    id: "Stroke-526",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.106235,
    y1: 252.067173,
    x2: 230.106235,
    y2: 217.982676,
    id: "Stroke-528",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.883765,
    y1: 261.774085,
    x2: 199.883765,
    y2: 261.553474,
    id: "Stroke-530",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 368.219197,
    x2: 103.591007,
    y2: 298.28531,
    id: "Stroke-532",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.556418,
    y1: 265.524483,
    x2: 138.556418,
    y2: 265.524483,
    id: "Stroke-534",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.327592,
    y1: 359.835955,
    x2: 124.989397,
    y2: 360.056567,
    id: "Stroke-536",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.965835,
    y1: 234.74916,
    x2: 218.965835,
    y2: 234.74916,
    id: "Stroke-538",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 386.08874,
    x2: 58.6985066,
    y2: 386.08874,
    id: "Stroke-540",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.708777,
    y1: 230.667845,
    x2: 223.708777,
    y2: 286.041365,
    id: "Stroke-542",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.6411111,
    y1: 340.422132,
    x2: 58.6985066,
    y2: 349.136291,
    id: "Stroke-544",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.6411111,
    y1: 340.422132,
    x2: 81.6411111,
    y2: 326.192682,
    id: "Stroke-546",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 351.121796,
    x2: 103.591007,
    y2: 348.805374,
    id: "Stroke-548",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 402.965529,
    x2: 56.9336908,
    y2: 403.627364,
    id: "Stroke-550",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.350399,
    y1: 277.327205,
    x2: 136.350399,
    y2: 271.480997,
    id: "Stroke-552",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.61288,
    y1: 296.124052,
    x2: 102.345525,
    y2: 296.557002,
    id: "Stroke-554",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75403462,
    y1: 74.6954216,
    x2: 7.51885036,
    y2: 74.0335867,
    id: "Stroke-556",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.51885036,
    y1: 74.0335867,
    x2: 18.8265395,
    y2: 78.3906664,
    id: "Stroke-558",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.704864,
    y1: 88.9248718,
    x2: 44.5799807,
    y2: 88.1527311,
    id: "Stroke-560",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.4405151,
    y1: 148.490012,
    x2: 48.4405151,
    y2: 280.195156,
    id: "Stroke-562",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.818145,
    y1: 224.821637,
    x2: 208.818145,
    y2: 209.930352,
    id: "Stroke-564",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.016873,
    y1: 226.035001,
    x2: 212.016873,
    y2: 211.143716,
    id: "Stroke-566",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 217.862825,
    y1: 228.351423,
    x2: 217.862825,
    y2: 213.349832,
    id: "Stroke-568",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.568378,
    y1: 226.255613,
    x2: 212.568378,
    y2: 211.254022,
    id: "Stroke-570",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.664097,
    y1: 227.138059,
    x2: 214.664097,
    y2: 212.136468,
    id: "Stroke-572",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 221.943962,
    y1: 270.157327,
    x2: 221.943962,
    y2: 272.473749,
    id: "Stroke-574",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.324969,
    y1: 222.063992,
    x2: 200.766173,
    y2: 221.84338,
    id: "Stroke-576",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.819078,
    y1: 230.667845,
    x2: 223.819078,
    y2: 232.873961,
    id: "Stroke-578",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.0772863,
    y1: 362.262683,
    x2: 81.7172188,
    y2: 360.939014,
    id: "Stroke-580",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.9596942,
    y1: 363.255436,
    x2: 83.4820345,
    y2: 361.600849,
    id: "Stroke-582",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 368.438798,
    x2: 58.9954001,
    y2: 368.550023,
    id: "Stroke-584",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.9952162,
    y1: 385.095987,
    x2: 58.6983227,
    y2: 384.984762,
    id: "Stroke-586",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.972126,
    y1: 351.385151,
    x2: 103.446421,
    y2: 351.563479,
    id: "Stroke-588",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.458077,
    y1: 5.97489836,
    x2: 198.891056,
    y2: 0.790525013,
    id: "Stroke-590",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.841886,
    y1: 15.0199753,
    x2: 237.717002,
    y2: 14.2478345,
    id: "Stroke-592",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.717002,
    y1: 15.6818101,
    x2: 237.717002,
    y2: 14.2478345,
    id: "Stroke-594",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.717002,
    y1: 15.6818101,
    x2: 432.962611,
    y2: 90.1501856,
    id: "Stroke-596",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.6985066,
    y1: 385.537211,
    x2: 61.1251282,
    y2: 384.654764,
    id: "Stroke-598",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.806185,
    y1: 356.416475,
    x2: 134.695884,
    y2: 356.416475,
    id: "Stroke-600",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.891056,
    y1: 0.790525013,
    x2: 200.655872,
    y2: 0.128690118,
    id: "Stroke-602",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 237.717002,
    y1: 14.2478345,
    x2: 200.655872,
    y2: 0.128690118,
    id: "Stroke-604",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.355067,
    y1: 6.08520417,
    x2: 201.427979,
    y2: 9.83560191,
    id: "Stroke-606",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.663163,
    y1: 9.28407283,
    x2: 199.663163,
    y2: 9.17376701,
    id: "Stroke-608",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.812721,
    y1: 162.940074,
    x2: 239.812721,
    y2: 162.940074,
    id: "Stroke-610",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.59941,
    y1: 393.920453,
    x2: 238.709711,
    y2: 393.920453,
    id: "Stroke-612",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.6747657,
    y1: 394.913205,
    x2: 30.9026588,
    y2: 394.582287,
    id: "Stroke-614",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5052018,
    y1: 397.67085,
    x2: 25.8288136,
    y2: 397.119321,
    id: "Stroke-616",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 395.464734,
    x2: 31.6747657,
    y2: 394.913205,
    id: "Stroke-618",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.665388,
    y1: 128.634966,
    x2: 471.775689,
    y2: 128.634966,
    id: "Stroke-620",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 395.464734,
    x2: 30.3511539,
    y2: 396.457486,
    id: "Stroke-622",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5052018,
    y1: 397.67085,
    x2: 24.5052018,
    y2: 398.663603,
    id: "Stroke-624",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6592497,
    y1: 399.325438,
    x2: 19.2107546,
    y2: 399.104826,
    id: "Stroke-626",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.9828615,
    y1: 399.435743,
    x2: 21.3064733,
    y2: 399.876967,
    id: "Stroke-628",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.8288136,
    y1: 397.119321,
    x2: 27.1524254,
    y2: 397.67085,
    id: "Stroke-630",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 380.242531,
    x2: 30.3511539,
    y2: 380.242531,
    id: "Stroke-632",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8132976,
    y1: 402.193389,
    x2: 12.8132976,
    y2: 403.186141,
    id: "Stroke-634",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.85704446,
    y1: 404.399505,
    x2: 6.85704446,
    y2: 405.392257,
    id: "Stroke-636",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6592497,
    y1: 399.987272,
    x2: 18.6592497,
    y2: 400.980025,
    id: "Stroke-638",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.29095724,
    y1: 403.847976,
    x2: 9.61456904,
    y2: 404.399505,
    id: "Stroke-640",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1369094,
    y1: 401.64186,
    x2: 15.4605211,
    y2: 402.193389,
    id: "Stroke-642",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.85704446,
    y1: 404.399505,
    x2: 8.29095724,
    y2: 403.847976,
    id: "Stroke-644",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8132976,
    y1: 402.193389,
    x2: 14.1369094,
    y2: 401.64186,
    id: "Stroke-646",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.6592497,
    y1: 399.987272,
    x2: 19.9828615,
    y2: 399.435743,
    id: "Stroke-648",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.85704446,
    y1: 403.73767,
    x2: 7.40854937,
    y2: 403.517059,
    id: "Stroke-650",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.8132976,
    y1: 401.531554,
    x2: 13.2545015,
    y2: 401.310942,
    id: "Stroke-652",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.01109235,
    y1: 405.612869,
    x2: 3.76861693,
    y2: 406.605621,
    id: "Stroke-654",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.76861693,
    y1: 406.605621,
    x2: 6.85704446,
    y2: 405.392257,
    id: "Stroke-656",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.40854937,
    y1: 403.517059,
    x2: 8.29095724,
    y2: 403.847976,
    id: "Stroke-658",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.61456904,
    y1: 404.399505,
    x2: 12.8132976,
    y2: 403.186141,
    id: "Stroke-660",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2545015,
    y1: 401.310942,
    x2: 14.1369094,
    y2: 401.64186,
    id: "Stroke-662",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4605211,
    y1: 402.193389,
    x2: 18.6592497,
    y2: 400.980025,
    id: "Stroke-664",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.916486,
    y1: 373.734488,
    x2: 134.916486,
    y2: 358.732897,
    id: "Stroke-666",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.6411111,
    y1: 306.99947,
    x2: 58.6985066,
    y2: 315.823935,
    id: "Stroke-668",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 317.699134,
    x2: 103.591007,
    y2: 315.493018,
    id: "Stroke-670",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.591007,
    y1: 315.493018,
    x2: 81.6411111,
    y2: 306.99947,
    id: "Stroke-672",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 250.743504,
    x2: 221.061554,
    y2: 250.412586,
    id: "Stroke-674",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 250.743504,
    x2: 222.054263,
    y2: 253.059926,
    id: "Stroke-676",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.649515,
    y1: 239.161393,
    x2: 216.649515,
    y2: 245.117907,
    id: "Stroke-678",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.540413,
    y1: 133.929645,
    x2: 473.540413,
    y2: 129.2968,
    id: "Stroke-680",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.687838,
    y1: 222.615521,
    x2: 239.923022,
    y2: 221.953686,
    id: "Stroke-682",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.923022,
    y1: 221.953686,
    x2: 239.923022,
    y2: 221.733074,
    id: "Stroke-684",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.59941,
    y1: 393.920453,
    x2: 238.59941,
    y2: 393.920453,
    id: "Stroke-686",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.355067,
    y1: 6.08520417,
    x2: 209.479951,
    y2: 5.42336928,
    id: "Stroke-688",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.704864,
    y1: 126.334814,
    x2: 44.5799807,
    y2: 125.672979,
    id: "Stroke-690",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 433.501156,
    y1: 114.846739,
    x2: 471.699305,
    y2: 129.469613,
    id: "Stroke-692",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.962427,
    y1: 90.1502775,
    x2: 430.081733,
    y2: 89.0352696,
    id: "Stroke-694",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.3730273,
    y1: 73.7026693,
    x2: 27.3730273,
    y2: 75.1366449,
    id: "Stroke-696",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 471.665388,
    y1: 128.634966,
    x2: 432.962611,
    y2: 113.868694,
    id: "Stroke-698",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.01109235,
    y1: 405.612869,
    x2: 0.45958743,
    y2: 405.392257,
    id: "Stroke-700",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.01109235,
    y1: 125.87732,
    x2: 0.45958743,
    y2: 125.656709,
    id: "Stroke-702",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75247203,
    y1: 123.667159,
    x2: 20.7561633,
    y2: 118.026855,
    id: "Stroke-704",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.45958743,
    y1: 125.656709,
    x2: 5.75219628,
    y2: 123.667527,
    id: "Stroke-706",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5052018,
    y1: 397.009015,
    x2: 25.0567067,
    y2: 396.788404,
    id: "Stroke-708",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.2107546,
    y1: 399.104826,
    x2: 19.9828615,
    y2: 399.435743,
    id: "Stroke-710",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3064733,
    y1: 399.876967,
    x2: 24.5052018,
    y2: 398.663603,
    id: "Stroke-712",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.0567067,
    y1: 396.788404,
    x2: 25.8288136,
    y2: 397.119321,
    id: "Stroke-714",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.1524254,
    y1: 397.67085,
    x2: 30.3511539,
    y2: 396.457486,
    id: "Stroke-716",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.9026588,
    y1: 347.812622,
    x2: 30.3511539,
    y2: 348.033233,
    id: "Stroke-718",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.3511539,
    y1: 347.59201,
    x2: 30.9026588,
    y2: 347.812622,
    id: "Stroke-720",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.4094831,
    y1: 79.21796,
    x2: 22.4094831,
    y2: 79.3282659,
    id: "Stroke-722",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244.665964,
    y1: 162.388545,
    x2: 241.467236,
    y2: 163.601909,
    id: "Stroke-724",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.427979,
    y1: 9.94590772,
    x2: 201.427979,
    y2: 9.83560191,
    id: "Stroke-726",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.783556,
    y1: 415.650698,
    x2: 243.783556,
    y2: 415.430087,
    id: "Stroke-728",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.906572,
    y1: 22.7413824,
    x2: 211.906572,
    y2: 22.7413824,
    id: "Stroke-730",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.9983775,
    y1: 395.464734,
    x2: 31.6747657,
    y2: 394.913205,
    id: "Stroke-732",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.197106,
    y1: 394.25137,
    x2: 34.2116883,
    y2: 394.913205,
    id: "Stroke-734",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 225.220361,
    y1: 19.1171009,
    x2: 223.455545,
    y2: 18.3449602,
    id: "Stroke-736",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.9482731,
    y1: 84.1817218,
    x2: 54.9482731,
    y2: 91.7928231,
    id: "Stroke-738",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.865448,
    y1: 275.231395,
    x2: 141.865448,
    y2: 269.385186,
    id: "Stroke-740",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.687838,
    y1: 222.615521,
    x2: 241.687838,
    y2: 217.982676,
    id: "Stroke-742",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.054263,
    y1: 233.646102,
    x2: 223.708777,
    y2: 233.017359,
    id: "Stroke-744",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.1229379,
    y1: 262.186813,
    x2: 10.995905,
    y2: 259.637829,
    id: "Stroke-746",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.1864558,
    y1: 261.01656,
    x2: 18.1681345,
    y2: 256.90583,
    id: "Stroke-748",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.2335175,
    y1: 264.672187,
    x2: 18.0589366,
    y2: 266.352512,
    id: "Stroke-750",
    strokeWidth: 0.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.2049283,
    y1: 265.913219,
    x2: 11.0107957,
    y2: 269.094623,
    id: "Stroke-752",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-755",
    strokeWidth: 0.2,
    points: "325 328 325.352941 327.75 325.823529 327.625 326.176471 327.375 326.411765 327.125 326.647059 326.875 326.882353 326.5 327 326.25 327 326"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-756",
    strokeWidth: 2,
    points: "327 327 327 326.75 326.882353 326.5 326.647059 326.25 326.411765 325.875 326.176471 325.625 325.823529 325.5 325.352941 325.25 325 325"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.5,
    y1: 327,
    x2: 327.5,
    y2: 329,
    id: "Stroke-757",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.5,
    y1: 329,
    x2: 327.5,
    y2: 331,
    id: "Stroke-758",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-759",
    strokeWidth: 2,
    points: "325 333 325.352941 332.75 325.823529 332.5 326.176471 332.25 326.411765 332 326.647059 331.75 326.882353 331.5 327 331.25 327 331"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325,
    y1: 324,
    x2: 235,
    y2: 290,
    id: "Stroke-760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261,
    y1: 352,
    x2: 325,
    y2: 328,
    id: "Stroke-761",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325,
    y1: 333,
    x2: 261,
    y2: 357,
    id: "Stroke-762",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 388,
    x2: 246,
    y2: 355,
    id: "Stroke-763",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-764",
    strokeWidth: 0.35,
    points: "252 357.08 252.777778 357.32 253.777778 357.56 254.888889 357.8 256 357.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-765",
    strokeWidth: 0.2,
    points: "252 353.08 252.975904 353.44 254.060241 353.68 255.253012 353.92 257.855422 353.92 259.048193 353.68 260.13253 353.44 261 353.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-766",
    strokeWidth: 2,
    points: "256 357.92 257.382979 357.8 258.87234 357.68 260.042553 357.44 260.574468 357.32 261 357.08"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 355,
    x2: 215,
    y2: 343,
    id: "Stroke-767",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 374,
    x2: 246,
    y2: 416,
    id: "Stroke-768",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 397,
    x2: 238,
    y2: 394,
    id: "Stroke-770",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 297,
    x2: 252,
    y2: 353,
    id: "Stroke-771",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.86,
    y1: 392,
    x2: 249.14,
    y2: 396,
    id: "Stroke-772",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 398,
    x2: 255,
    y2: 394,
    id: "Stroke-773",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252,
    y1: 357,
    x2: 245,
    y2: 354,
    id: "Stroke-774",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 246,
    y1: 395,
    x2: 253,
    y2: 358,
    id: "Stroke-775",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257,
    y1: 394,
    x2: 246,
    y2: 398,
    id: "Stroke-776",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 398.14,
    x2: 246,
    y2: 398.86,
    id: "Stroke-777",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.5,
    y1: 398,
    x2: 245.5,
    y2: 416,
    id: "Stroke-778",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 394.02,
    x2: 252,
    y2: 394.98,
    id: "Stroke-779",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257,
    y1: 394,
    x2: 250,
    y2: 391,
    id: "Stroke-780",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.5,
    y1: 396.5,
    x2: 245.5,
    y2: 396.5,
    id: "Stroke-781",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.32,
    y1: 397,
    x2: 245.68,
    y2: 395,
    id: "Stroke-782",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256,
    y1: 358,
    x2: 250,
    y2: 392,
    id: "Stroke-783",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.5,
    y1: 397.5,
    x2: 245.5,
    y2: 397.5,
    id: "Stroke-784",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.5,
    y1: 411,
    x2: 256.5,
    y2: 394,
    id: "Stroke-785",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257,
    y1: 393.86,
    x2: 255,
    y2: 393.14,
    id: "Stroke-786",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 416,
    x2: 256,
    y2: 412,
    id: "Stroke-787",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 343,
    x2: 106,
    y2: 301,
    id: "Stroke-789",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: 353,
    x2: 239,
    y2: 390,
    id: "Stroke-790",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 356,
    x2: 244,
    y2: 398,
    id: "Stroke-791",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238,
    y1: 394,
    x2: 137,
    y2: 355,
    id: "Stroke-792",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 400,
    x2: 135,
    y2: 358,
    id: "Stroke-793",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179,
    y1: 269,
    x2: 106,
    y2: 297,
    id: "Stroke-794",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235,
    y1: 290,
    x2: 179,
    y2: 269,
    id: "Stroke-795",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.5,
    y1: 299,
    x2: 105.5,
    y2: 297,
    id: "Stroke-796",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 361,
    x2: 215,
    y2: 343,
    id: "Stroke-797",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 388,
    x2: 169,
    y2: 361,
    id: "Stroke-798",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 348,
    x2: 175,
    y2: 341,
    id: "Stroke-799",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.5,
    y1: 348,
    x2: 155.5,
    y2: 320,
    id: "Stroke-800",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137,
    y1: 355,
    x2: 155,
    y2: 348,
    id: "Stroke-801",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: 352,
    x2: 175,
    y2: 341,
    id: "Stroke-802",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 335,
    x2: 149,
    y2: 353,
    id: "Stroke-803",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.5,
    y1: 328,
    x2: 176.5,
    y2: 340,
    id: "Stroke-804",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: 361,
    x2: 146,
    y2: 352,
    id: "Stroke-805",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177,
    y1: 340,
    x2: 192,
    y2: 334,
    id: "Stroke-806",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.44,
    y1: 340.44,
    x2: 175.56,
    y2: 340.56,
    id: "Stroke-807",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.5,
    y1: 329,
    x2: 177.5,
    y2: 340,
    id: "Stroke-808",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.62,
    y1: 339.56,
    x2: 177.38,
    y2: 339.44,
    id: "Stroke-809",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156.5,
    y1: 321,
    x2: 156.5,
    y2: 348,
    id: "Stroke-810",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177,
    y1: 339,
    x2: 191,
    y2: 334,
    id: "Stroke-811",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.86,
    y1: 347.62,
    x2: 155.14,
    y2: 347.38,
    id: "Stroke-812",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175.5,
    y1: 341,
    x2: 175.5,
    y2: 328,
    id: "Stroke-813",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175,
    y1: 340.86,
    x2: 177,
    y2: 340.14,
    id: "Stroke-814",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.5,
    y1: 301,
    x2: 105.5,
    y2: 299,
    id: "Stroke-815",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 91,
    x2: 226,
    y2: 26,
    id: "Stroke-816",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-817",
    strokeWidth: 0.35,
    points: "407 94 407.315789 94.2142857 407.526316 94.3214286 407.736842 94.4285714 407.947368 94.6428571 408.052632 94.75 408.157895 94.8571429 408.368421 95.0714286 408.578947 95.3928571 408.789474 95.7142857 408.894737 96.1428571 408.894737 96.3571429 409 96.5714286 409 97"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    y1: 26,
    x2: 407,
    y2: 94,
    id: "Stroke-818",
    strokeWidth: 0.35
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-819",
    strokeWidth: 0.35,
    points: "226 25.62 226.285714 25.5 226.666667 25.38 227.428571 25.38 227.714286 25.5 228 25.62"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-824",
    transform: "translate(10.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.691732679,2.61698178 L7.30737476,0 C7.69028227,0 8,0.310140942 8,0.692677896 L8,9.68944655 C8,10.0719835 7.69028227,10.3830182 7.30737476,10.3830182 L0.691732679,13 C0.309717728,13 0,12.6898591 0,12.3073221 L0,3.30965968 C0,2.92712272 0.309717728,2.61698178 0.691732679,2.61698178 Z",
    id: "Stroke-820",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.20439585,5.94514266 L6.48309718,4.92355449 C6.57949347,4.92355449 6.6580386,5.01471983 6.6580386,5.12733585 L6.6580386,7.76398075 C6.6580386,7.87570299 6.57949347,7.96686834 6.48309718,7.96686834 L4.20439585,8.98845651 C4.107107,8.98845651 4.02856187,8.89729117 4.02856187,8.78556892 L4.02856187,6.14803025 C4.02856187,6.03630801 4.107107,5.94514266 4.20439585,5.94514266 Z",
    id: "Stroke-822",
    strokeWidth: 0.15
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-825",
    strokeWidth: 0.35,
    points: "36 286 36 284.34683 36.5515899 284.166434 38.7579494 285.054539 41.8468527 283.833395 41.8468527 282.161723 42.3984426 281.946173 44.6048021 282.834277 47.6937054 281.613134 47.6937054 279.996968 48.2452953 279.725912 50.3661583 280.503003 53.5405581 279.281859 53.5405581 277.555606 54.092148 277.394637 56.2985075 278.282742 59.4977287 277.061598 59.4977287 275.371424 59.9390006 275.174376 62.1453602 276.158692 65.3445814 274.841337 65.3445814 273.146537 65.8961713 272.954115 67.9922128 273.731206 71.1914341 272.510062 71.1914341 270.814338 71.743024 270.62284 73.8390655 271.510945 77.0382868 270.289801 77.0382868 268.58575 77.5898767 268.402579 79.6859182 269.290683 82.8851395 268.06954 82.8851395 266.445049 83.4367294 266.182318 85.6430889 266.959409 88.7319922 265.738265 88.7319922 264.215536 89.2835821 263.962056 91.4899416 264.739148 94.5788449 263.518004 94.5788449 261.809328 95.1304348 261.630782 97.3367943 262.518886 100.425698 261.297743 100.425698 259.683428 100.977287 259.410521 103.183647 260.187612 106.27255 258.966468 106.27255 257.419686 106.82414 257.190259 109.0305 257.967351 112.229721 256.746207 112.229721 255.097663 112.670993 254.858985 114.877352 255.747089 118.076574 254.525946 118.076574 252.893129 118.628164 252.638724 120.724205 253.415815 123.923426 252.194671 123.923426 250.629387 124.475016 250.418462 126.571058 251.195554 129.770279 249.97441 129.770279 248.385073 130.321869 248.087188 132.41791 248.975292 135.617132 247.754149 135.617132 246.161111 136.168722 245.866927 138.375081 246.644018 141.463984 245.422874 141.463984 243.888119 142.015574 243.646665 144.221934 244.423757 147.310837 243.202613 147.310837 241.584598 147.862427 241.315391 150.068787 242.203495 153.15769 240.982352 153.15769 239.370812 153.70928 239.09513 155.915639 239.872221 159.11486 238.651077 159.11486 237.037688 159.556132 236.874868 161.762492 237.65196 164.961713 236.430816 164.961713 234.853505 165.513303 234.543594 167.609345 235.48813 170.808566 234.210555 170.808566 232.535183 171.360156 232.323333 173.456197 233.100424 176.655419 231.87928 176.655419 230.453688 177.207008 230.103071 179.30305 230.880163 182.502271 229.659019 182.502271 228.131664 183.053861 227.771797 185.260221 228.721884 188.349124 227.438758 188.349124 225.818892 188.900714 225.551536 191.107073 226.468319 194.195977 225.107483 194.195977 223.515371 194.747567 223.331274 196.953926 224.108366 200.042829 222.887222 200.042829 221.222026 200.594419 221 206 222.998235"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-834",
    transform: "translate(119.000000, 254.000000)",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1881796,1.70289459 C4.14934537,1.71999876 4.10866188,1.73509066 4.06890303,1.74917644 C4.02637029,1.76527448 3.98383756,1.77936026 3.94038021,1.79344604 C3.89414898,1.80753182 3.84884237,1.82061148 3.80261114,1.83369113 C3.75360604,1.84677079 3.70460093,1.85884431 3.65559583,1.86991171 C3.56775649,1.89003426 3.4780679,1.90814455 3.39022857,1.92223033 C3.29591686,1.93832836 3.20068052,1.95140802 3.10636881,1.96146929 C2.74206672,2.00171438 2.36297063,2.00473276 1.99774392,1.97153056 C1.90250758,1.96348154 1.80819587,1.95241414 1.71388416,1.93832836 C1.69076855,1.93530998 1.66857756,1.9322916 1.64546194,1.92826709 C1.63436645,1.92726096 1.62327095,1.92524871 1.61217546,1.92323645 C1.60107996,1.9212242 1.58998447,1.91921195 1.57888897,1.91719969 C1.53543161,1.90915067 1.49197426,1.90210778 1.44759228,1.89305264 C1.35512982,1.87393622 1.26174273,1.85180142 1.1702049,1.82564211 C1.12582292,1.81356859 1.08144093,1.79948281 1.03798358,1.78640315 C0.994526222,1.77231737 0.951993491,1.75722546 0.910385384,1.74213355 C0.862304904,1.72402326 0.814224425,1.70490685 0.767993195,1.68377818 C0.722686589,1.66466176 0.679229233,1.64353309 0.635771877,1.62039216 C0.595088394,1.60026962 0.555329536,1.57712869 0.516495303,1.55298164 C0.480434943,1.53084684 0.445299209,1.50669978 0.412012723,1.4815466 C0.387047859,1.46343631 0.363007619,1.4443199 0.340816628,1.42419735 C0.319550263,1.40508094 0.299208521,1.38596452 0.27886678,1.36483585 C0.261298913,1.34571943 0.243731045,1.32559688 0.227087802,1.30446821 C0.212293809,1.2853518 0.19842444,1.26422312 0.185479695,1.24410058 C0.173459575,1.22397804 0.16236408,1.20385549 0.153117834,1.18172069 C0.143871588,1.16260428 0.136474591,1.1414756 0.130002219,1.12135306 C0.118906724,1.08110797 0.112434352,1.04086288 0.112434352,0.999611665",
    id: "Stroke-826"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1881796,1.70289459 C4.26677269,1.67069852 4.34351653,1.63447794 4.41841113,1.5922206 C4.49145647,1.55096938 4.56542644,1.50267528 4.63107478,1.44834441 C4.69672313,1.39401354 4.76052223,1.32962139 4.80767808,1.25516798 C4.82062283,1.23504544 4.83171832,1.21592902 4.84096457,1.19480035 C4.85021081,1.1746778 4.85853244,1.15556138 4.86592943,1.13443271 C4.8797988,1.09116924 4.8871958,1.04589352 4.8871958,0.999611665",
    id: "Stroke-828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.112804201,1.00001412 C0.112804201,0.953732264 0.120201198,0.909462666 0.134070567,0.866199196 C0.141467564,0.845070524 0.149789186,0.82494798 0.159035432,0.805831563 C0.169206302,0.784702891 0.180301797,0.764580347 0.192321917,0.745463929 C0.239477772,0.671010515 0.30327687,0.605612246 0.368925216,0.552287503 C0.435498188,0.496950506 0.508543531,0.449662527 0.5825135,0.407405183 C0.656483468,0.366153967 0.734151934,0.329933387 0.811820401,0.296731189",
    id: "Stroke-830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88747319,1.00001412 C4.88747319,0.9587629 4.88100081,0.918517811 4.86990532,0.87927885 C4.86343295,0.858150178 4.85603595,0.838027634 4.84771433,0.817905089 C4.83754346,0.796776418 4.82737259,0.775647746 4.81442784,0.756531329 C4.80240772,0.735402657 4.78761373,0.715280113 4.77281974,0.696163696 C4.75617649,0.675035024 4.73953325,0.65491248 4.72104076,0.635796062 C4.70162364,0.614667391 4.6812819,0.594544846 4.66001553,0.576434556 C4.63689992,0.555305885 4.61285968,0.536189468 4.58881944,0.519085305 C4.55460833,0.492925997 4.51947259,0.468778944 4.48341223,0.446644145 C4.44550263,0.422497092 4.40481914,0.400362293 4.36506029,0.379233621 C4.32160293,0.356092695 4.27722095,0.334964023 4.23283897,0.315847606 C4.18568311,0.295725062 4.13760263,0.276608645 4.08952215,0.258498355 C4.04698942,0.242400319 4.00538132,0.228314538 3.96284858,0.214228757 C3.9184666,0.200142976 3.87408462,0.187063322 3.82970264,0.173983668 C3.73816481,0.148830487 3.64477772,0.126695689 3.55231526,0.107579271 C3.5088579,0.0985241264 3.46540055,0.0904751087 3.42101857,0.0824260909 C3.40992307,0.0814199637 3.39882758,0.0794077092 3.38773208,0.0773954548 C3.37663659,0.0753832004 3.36554109,0.0733709459 3.3544456,0.0723648187 C3.3322546,0.0683403098 3.30913899,0.0653219282 3.28602337,0.0612974193 C3.19263629,0.0472116382 3.09739996,0.037150366 3.00216362,0.028095221 C2.63786153,-0.00410085009 2.25784082,-0.00108246842 1.89353872,0.0381564932 C1.79922701,0.0482177654 1.7049153,0.0623035465 1.61060359,0.0773954548 C1.52183963,0.0924873631 1.43307567,0.109591526 1.34431171,0.12971407 C1.29530661,0.141787597 1.24722613,0.153861124 1.19822102,0.166940777 C1.15198979,0.179014304 1.10575856,0.193100085 1.06045196,0.207185866 C1.0169946,0.22026552 0.973537244,0.235357428 0.931004512,0.251455464 C0.891245654,0.265541245 0.851486796,0.280633153 0.811727938,0.296731189",
    id: "Stroke-832"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBedTable);
export default __webpack_public_path__ + "static/media/cloud_bed_table.231fb9646dd05394b429aebce7069d79.svg";
export { ForwardRef as ReactComponent };